import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/lib/store';
import { localeAdapter } from '@/entities/locale/model/locale.slice';

const baseSelectors = localeAdapter.getSelectors(
	(state: RootState) => state.locales,
);

const selectActiveLocale = createSelector(
	[
		baseSelectors.selectEntities,
		(state: RootState) => state.locales.activeLocaleId,
	],
	(entities, activeLocaleId) =>
		activeLocaleId ? entities[activeLocaleId] : undefined,
);

const localeSliceSelectors = {
	...baseSelectors,
	selectActiveLocale,
};

export { localeSliceSelectors };
